export enum TaxTypeEnum {
	TAXES = 'taxes',
	TAX_EXEMPT = 'taxExemptAmount',
	TAX_SUBJECT = 'taxSubjectAmount'
}
